import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
import { sizes } from '../../const/sizes';
const StyledSplitButtonContainer = styled('div', {
    display: 'flex',
    height: sizes.button.smallHeight,
    borderRadius: sizes.button.borderRadius,
    overflow: 'hidden',
    backgroundColor: staticColors.buttonLightActionBackground,
});
export const SplitButtonContainer = ({ children, }) => (_jsx(StyledSplitButtonContainer, { children: children }));
